var staticDecodeURIComponent = decodeURIComponent

module.exports = staticDecodeURIComponent



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/staticDecodeURIComponent.js
// module id = 448
// module chunks = 75